export default "__VITE_ASSET__iJfzHtbw__"